<template>
  <ul class="cordel-boolean">
    <li
      v-for="(option, index) in items"
      :key="option.value"
      ref="options"
      class="cordel-boolean-option"
    >
      <label
        :tabindex="disabled ? -1 : 0"

        :class="classes[index]"

        @blur="blur"
        @focus="focus"

        @keydown.enter.exact="e => input(e, option)"
        @keydown.space.exact.prevent="e => input(e, option)"
      >
        <input
          :id="name"
          :name="name"
          :disabled="disabled"

          :value="option.value"
          :checked="value === option.value"

          class="cordel-boolean-radio"
          type="radio"
          tabindex="-1"

          @input="e => input(e, option)"
        >

        <span class="cordel-boolean-text">
          {{ option.label }}
        </span>
      </label>
    </li>
  </ul>
</template>

<script>
  const DEFAULT_OPTIONS = [{
    label: 'Sim',
    value: true,
  }, {
    label: 'Não',
    value: false,
  }];

  export default {
    name: 'CordelBoolean',
    props: {
      name: {
        type: String,
        default: '',
      },
      value: {
        type: [String, Number, Boolean],
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      errors: {
        type: Array,
        default() {
          return [];
        },
      },
      options: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      items() {
        return this.options.length ? this.options : DEFAULT_OPTIONS;
      },
      classes() {
        return this.items.map(this.class);
      },
    },
    methods: {
      input(e, option) {
        if (this.disabled) {
          return;
        }

        this.$emit('input', option.value);
        this.$emit('change', e);
      },
      blur(e) {
        this.$emit('blur', e);
      },
      focus(e) {
        this.$emit('focus', e);
      },
      activate() {
        try {
          this.$refs.options[0].children[0].focus();
        } catch (err) { /* */ }
      },
      class(option) {
        const classes = ['cordel-boolean-label'];

        if (option.value === this.value) {
          classes.push('state--checked');
        }

        if (this.errors.length) {
          classes.push('state--error');
        }

        if (this.disabled) {
          classes.push('state--disabled');
        }

        if (this.loading) {
          classes.push('state--loading');
        }

        return classes;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-boolean {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
  }

  .cordel-boolean-label {
    background-color: var(--cordel-color-neutral-lighter);
    box-shadow: 0 0 0 var(--cordel-border-width-soft) var(--cordel-color-neutral-primary);
    cursor: pointer;
    display: block;
    padding: var(--cordel-spacing-xxxs) var(--cordel-spacing-xs);
    transition: background-color .1s,
                box-shadow .1s,
                color .1s;

    &:focus:not(.state--disabled):not(.state--loading) {
      box-shadow: 0 0 0 var(--cordel-border-width-thin) var(--cordel-color-highlight-primary);
      outline: none;
      position: relative;
    }
  }

  .cordel-boolean-radio {
    display: none;
  }

  .cordel-boolean-option {
    flex: 1;
    list-style: none;

    & + & {
      margin-left: calc(-1 * var(--cordel-border-width-soft));
    }

    &:first-child {
      .cordel-boolean-label {
        border-radius: var(--cordel-border-radius-small) 0 0 var(--cordel-border-radius-small);
      }
    }

    &:last-child {
      .cordel-boolean-label {
        border-radius: 0 var(--cordel-border-radius-small) var(--cordel-border-radius-small) 0;
      }
    }
  }

  .state--checked {
    background-color: var(--cordel-color-brand-primary);
    color: var(--cordel-color-constant-light);
  }

  .state--error {
    box-shadow: 0 0 0 var(--cordel-border-width-thin) var(--cordel-color-alert-danger);
  }

  .state--disabled {
    background-color: transparent;
    box-shadow: inset 0 0 0 var(--cordel-border-width-soft) var(--cordel-color-neutral-primary);
    color: var(--cordel-color-neutral-primary);
    cursor: not-allowed;

    &.state--checked {
      background-color: var(--cordel-color-neutral-lighter);
      // color: var(--cordel-color-constant-light);
    }
  }

  .state--loading {
    cursor: progress;
  }
</style>
